<div class="content">
  <img loading="lazy" src="../../../../assets/images/common/empty.svg" alt="">
  <p>
    {{"GLOBALS.NO_RESULTS" |translate}}
  </p>
</div>